import {
  SET_CUSTOMER_SUPPORT_CREDENTIALS_LOADING,
  SET_CUSTOMER_SUPPORT_CREDENTIALS_SUCCESS,
  SET_CUSTOMER_SUPPORT_CREDENTIALS_FAILED,
  SET_CUSTOMER_SUPPORT_CREDENTIALS_RESET,
} from "../types";

const initialState = {
  loading: false,
  error: null as string | null,
  success: false,
};

export const setCustomerSupportCredentialsReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SET_CUSTOMER_SUPPORT_CREDENTIALS_LOADING:
      return { ...state, loading: true, error: null, success: false };
    case SET_CUSTOMER_SUPPORT_CREDENTIALS_SUCCESS:
      return { ...state, loading: false, error: null, success: true };
    case SET_CUSTOMER_SUPPORT_CREDENTIALS_FAILED:
      return { ...state, loading: false, error: action.payload, success: false };
    case SET_CUSTOMER_SUPPORT_CREDENTIALS_RESET:
      return initialState;
    default:
      return state;
  }
};
